import React, { Suspense } from 'react'
import { Switch } from 'react-router-dom'
import { UnknownErrorPage } from '@maui/elements'

import AppRoute from './AppRoute'
import NotFound from './NotFound'
import routes from './routes'
import { anyAuth } from './authStates'
import { PageLoading } from '../Page'

export default function Router() {
  return (
    <UnknownErrorPage.ErrorBoundary>
      <Suspense fallback={<PageLoading />}>
        <Switch>
          {Object.values(routes).map((route, i) =>
            <AppRoute key={i} {...route.props} />
          )}
          <AppRoute name="notFound" path="*" authState={anyAuth}>
            <NotFound />
          </AppRoute>
        </Switch>
      </Suspense>
    </UnknownErrorPage.ErrorBoundary>
  )
}
